module.exports = __webpack_public_path__ + "static/media/DSC_0252.8af04388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0252.jpg
// module id = 653
// module chunks = 0